import TableFooter from '@/components/TableFooter/TableFooter';

export default TableFooter;
